// removed by extract-text-webpack-plugin
module.exports = {"green":"green--1I0gO","red":"red--22Ncr","blue":"blue--2WhHm","yellow":"yellow--1Ctpk"};


//////////////////
// WEBPACK FOOTER
// ./src/Pad/Pad.css
// module id = CRBD
// module chunks = 1